import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { changeUserPassword, createUserSaga } from "src/store/users/saga";
import { UserDetailDto } from "src/store/users/type";
import * as Yup from "yup";

const ChangePassword = ({
  onHide,
  data,
  open,
  onSuccessClick,
}: {
  data: UserDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Users.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          ConfirmPassword: "",
          NewPassword: "",
        }}
        onSubmit={(values) => {
          dispatch(
            changeUserPassword({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(t(message), {
                    theme: "colored",
                  });
                },
              },
              body: values,
              id: data.Id,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          NewPassword: Yup.string().required(
            t("Validation.Required").toString()
          ),
          ConfirmPassword: Yup.string()
            .required(t("Validation.Required").toString())
            .oneOf(
              [Yup.ref("NewPassword")],
              t("Validation.PasswordNoMatched").toString()
            ),
        })}
        inputs={[
          {
            field: "NewPassword",
            type: "password",
            label: t("Users.Password").toString(),
          },
          {
            field: "ConfirmPassword",
            type: "password",
            label: t("Users.ConfirmPassword").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ChangePassword;
